import styled, {css} from 'styled-components';

import {Label as BaseLabel, TLabelProps} from '../FormField/primitives';
import {mixins} from '../styles';

export const Label = styled(BaseLabel)<TLabelProps>`
  ${({theme, disabled}) => css`
    color: ${disabled ? theme.branding.colors.disabled : theme.branding.content.primary};
  `}
`;

export const Hint = styled.div`
  ${mixins.f2}
  white-space: pre-line;
  color: ${({theme}) => theme.branding.content.secondary};
`;

export type TBorderProps = TTheme & {
  hasError?: boolean;
  noFocus?: boolean;
  hasMargin?: boolean;
  width?: string;
};

export const Border = styled.div<TBorderProps>`
  width: 100%;
  ${({theme, hasError, noFocus, width}) => css`
    max-width: ${width ?? '100%'};
    padding: ${theme.spacing.s4};
    border: 1px solid ${hasError ? theme.palette.red400 : theme.palette.grey100};
    border-radius: ${theme.borderRadius.br2};

    &:focus-within {
      border: 1px solid
        ${hasError
          ? theme.palette.red400
          : noFocus
            ? theme.palette.grey100
            : theme.branding.colors.accentA};
    }
  `}
`;
